'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconArrowRightThin, iconArrowRightThinTag } from '@ni/nimble-components/dist/esm/icons/arrow-right-thin';
import { wrap } from '../../utilities/react-wrapper';

export type { IconArrowRightThin };
export { iconArrowRightThinTag };
export const NimbleIconArrowRightThin = wrap(IconArrowRightThin);